import React, { createContext, useContext, useRef } from 'react';
import { useSlideBack } from '../../hooks/useSlideBack';
const SwipeableContext = createContext({
    statusMapRef: {
        current: {},
    },
    closeAll: () => { },
    addStatusRef: () => { },
    setCurStatus: () => { },
});
export function SwipeableStatusProvider(props) {
    const { children, onAllClose } = props;
    const { setSlideBack } = useSlideBack();
    function setCurStatus({ uid, isOpened, }) {
        statusMapRef.current = Object.assign(Object.assign({}, statusMapRef.current), { [uid]: Object.assign(Object.assign({}, statusMapRef.current[uid]), { isOpened: isOpened }) });
        if (isOpened) {
            Object.keys(statusMapRef.current).forEach((key) => {
                var _a, _b, _c;
                if (key !== uid) {
                    (_c = (_b = (_a = statusMapRef.current) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b.instance) === null || _c === void 0 ? void 0 : _c.close();
                }
            });
        }
        else {
            const isAllClosed = Object.keys(statusMapRef.current).every((key) => { var _a, _b; return !((_b = (_a = statusMapRef.current) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b.isOpened); });
            if (isAllClosed) {
                onAllClose === null || onAllClose === void 0 ? void 0 : onAllClose({ setSlideBack });
            }
        }
    }
    function addStatusRef({ uid, ref }) {
        statusMapRef.current = Object.assign(Object.assign({}, statusMapRef.current), { [uid]: {
                instance: ref,
                isOpened: false,
            } });
    }
    function closeAll() {
        Object.keys(statusMapRef.current).forEach((key) => {
            var _a, _b, _c, _d;
            (_d = (_c = (_b = (_a = statusMapRef.current) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b.instance) === null || _c === void 0 ? void 0 : _c.close) === null || _d === void 0 ? void 0 : _d.call(_c);
        });
        onAllClose === null || onAllClose === void 0 ? void 0 : onAllClose({ setSlideBack });
    }
    const statusMapRef = useRef({});
    return (React.createElement(SwipeableContext.Provider, { value: { statusMapRef, setCurStatus, addStatusRef, closeAll } }, children));
}
export function useSwipeableStatus() {
    return useContext(SwipeableContext);
}
